//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fullWidthVideo from "~/components/video-elements/fullWidthVideo";
export default {
  layout: "nav-fixed",

  data() {
    return {
      pageLoaded: false,
      displays: [
        { shapetext: "70-80 c", time: "2-3 Minutes", name: "WHITE TEA" },
        { shapetext: "70-80 c", time: "2-3 Minutes", name: "GREEN TEA" },
        { shapetext: "80-90 c", time: "2-3 Minutes", name: "OOLONG TEA" },
        {
          shapetext: "95-100 c",
          time: "MEDIUM STRENGTH - 3 MINUTES <br> STRONG CUP - 4MINUTES <br> MILK TEA - 5 MINUTES",
          name: "BLACK TEA",
        },
        { shapetext: "95-100 c", time: "3-5 Minutes", name: "INFUSIONS" },
      ],

      selectedDisplay: null,
    };
  },
  head() {
    return {
      title: "How To Make Tea | Way To Brew the Perfect Cup Of Tea",
      meta: [
        {
          name: "description",
          hid: "description",
          content:
            "Discover the best ways to make different types of tea. Learn how to make tea with different tea recipes from world class chefs from around the world.",
        },
        {
          name: "og:description",
          hid: "og:description",
          content:
            "Discover the best ways to make different types of tea. Learn how to make tea with different tea recipes from world class chefs from around the world.",
        },
        {
          name: "keywords",
          hid: "keywords",
          content: "Dilmah",
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        // {
        //   property: "og:image",
        //   hid: "og:image",
        //   content: this.pageData.seo.share_image_url,
        // },
        {
          property: "og:title",
          hid: "og:title",
          content: "How To Make Tea | Way To Brew the Perfect Cup Of Tea",
        },
        // {
        //   property: "og:image:alt",
        //   hid: "og:image:alt",
        //   content: this.pageData.seo.share_image_alt,
        // },

        // {
        //   name: "shareImageAlt",
        //   hid: "shareImage",
        //   content: this.pageData.seo.share_image_alt,
        // },
        // {
        //   name: "shareImage",
        //   hid: "shareImage",
        //   content: this.pageData.seo.share_image_url,
        // },
        // {
        //   name: "preventindex",
        //   hid: "preventindex",
        //   content: this.pageData.seo.prevent_indexing,
        // },
      ],
    };
  },
  components: {
    fullWidthVideo,
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.pageLoaded = true;
      }, 100);
    });
  },
};
